module.exports = __webpack_public_path__ + "img/header_beanstandungs_formular_1192x282â__.ed9b45c7.jpg";